'use strict';

/**
 * [logging-helpers](https://github.com/helpers/logging-helpers).
 * @api public
 */

module.exports = require('logging-helpers');
